/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ 5669:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (/* binding */ GlobalDrawer)
/* harmony export */ });
class GlobalDrawer extends HTMLElement {
  constructor() {
    super();
    this.closeElements = this.querySelectorAll('[data-drawer-close]');
    this.openDrawer = this.openDrawer.bind(this);
    this.closeDrawer = this.closeDrawer.bind(this);
    this.closeAllDrawers = this.closeAllDrawers.bind(this);
    this.handleResize = this.handleResize.bind(this);
  }

  connectedCallback() {
    window.wetheme.webcomponentRegistry.register({key: 'component-drawer'});
    window.eventBus.on('close:all:drawers', this.closeAllDrawers);
    this.closeElements.forEach((element) => {
      element.addEventListener('click', this.closeDrawer);
    });

    if (window.Shopify.designMode) {
      window.addEventListener('resize', this.handleResize);
    }
  }

  openDrawer() {
    window.eventBus.emit('close:all:drawers', this);
    this.setAttribute('aria-hidden', 'false');
    document.body.classList.add('js-drawer-open');
    this.addEventListener('transitionend', this.handleTransitionEnd);
    window.eventBus.emit('drawer:opened', this);
  }

  closeDrawer() {
    this.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('js-drawer-open');
    this.removeEventListener('transitionend', this.handleTransitionEnd);
    window.eventBus.emit('drawer:closed', this);
  }

  closeAllDrawers(e) {
    if (e === this) return;
    this.closeDrawer();
  }

  handleTransitionEnd(e) {
    if (e.target === this) {
      this.trapFocus();
    }
  }

  trapFocus() {
    const focusableElements = this.querySelectorAll('button, [href], input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])');
    if (focusableElements.length === 0) return;
    const firstFocusableElement = focusableElements[0];
    const lastFocusableElement = focusableElements[focusableElements.length - 1];
    firstFocusableElement.focus();
    this.addEventListener('keydown', (e) => {
      if (e.key === 'Tab') {
        if (e.shiftKey) {
          if (document.activeElement === firstFocusableElement) {
            lastFocusableElement.focus();
            e.preventDefault();
          }
        } else {
          if (document.activeElement === lastFocusableElement) {
            firstFocusableElement.focus();
            e.preventDefault();
          }
        }
      }
    });
  }

  handleResize() {
    this.classList.add('disable-transitions');
    setTimeout(() => {
      this.classList.remove('disable-transitions');
    }, 500);
  }

  disconnectedCallback() {
    if (window.Shopify.designMode) {
      window.removeEventListener('resize', this.handleResize);
    }
  }
}

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	function __webpack_require__(moduleId) {
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	(() => {
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
/* harmony import */ var _global_drawer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5669);


class CartDrawer extends _global_drawer__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A {
  constructor() {
    super();
    this.dynamicContentIds = [
      'cart-header',
      'cart-body',
      'cart-footer'
    ];
    this.scrollElement = this.querySelector('[data-cart-scroll-element]');
    this.handleCartOpen = this.handleCartOpen.bind(this);
    this.handleCartUpdate = this.handleCartUpdate.bind(this);
    this.handleCartRender = this.handleCartRender.bind(this);

    // Track the most recently added item so we can highlight it after re-render
    this.pendingAddedItemKey = null;
    this.HIGHLIGHT_CLASS = 'cart-item--just-added';
    this.HIGHLIGHT_DURATION = 1800; // ms — long enough to notice, short enough not to linger
  }

  connectedCallback() {
    super.connectedCallback();
    window.wetheme.webcomponentRegistry.register({key: 'component-cart-drawer'});
    window.eventBus.on('open:cart:drawer', this.handleCartOpen);
    window.eventBus.on('update:cart:drawer', this.handleCartUpdate);
    window.eventBus.on('render:cart:drawer', this.handleCartRender);
  }

  handleCartOpen(e) {
    /* ===== Capture the just-added item key (if provided) so we can highlight it post-render ===== */
    if (e?.addedItemKey) {
      this.pendingAddedItemKey = e.addedItemKey;
    }

    /* ===== Scroll to top of the cart if necessary ===== */
    if (e?.scrollToTop && this.scrollElement) {
      this.scrollElement.scrollTo(0, 0);
    }

    /* ===== Open the drawer ===== */
    this.openDrawer();

    /* ===== Highlight the new item once the drawer is open and content is in the DOM ===== */
    if (this.pendingAddedItemKey) {
      // Defer to next tick so any pending re-render has a chance to settle
      requestAnimationFrame(() => this.highlightAddedItem());
    }
  }

  handleCartUpdate(e) {
    if (!e) return;
    if (e?.addedItemKey) {
      this.pendingAddedItemKey = e.addedItemKey;
    }
    if (e.sections?.['cart-drawer']) {
      this.renderCartDrawer(e.sections['cart-drawer']);
    }
  }

  renderCartDrawer(html) {
    /* ===== Re-render cart drawer with updated content ===== */
    this.dynamicContentIds.forEach((id) => {
      const selector = `[data-cart-dynamic-content="${id}"]`;
      const updatedContent = this.getContent(html, selector);
      const targetElement = this.querySelector(selector);
      if (targetElement) {
        targetElement.innerHTML = updatedContent;
      }
    });
    this.trapFocus();

    /* ===== Highlight the new item after re-render ===== */
    if (this.pendingAddedItemKey) {
      requestAnimationFrame(() => this.highlightAddedItem());
    }
  }

  highlightAddedItem() {
    if (!this.pendingAddedItemKey) return;

    // Match either Shopify line item key or variant id, whichever the markup exposes
    const escapedKey = CSS.escape(this.pendingAddedItemKey);
    const itemEl = this.querySelector(
      `[data-cart-item-key="${escapedKey}"], [data-variant-id="${escapedKey}"]`
    );

    if (!itemEl) {
      this.pendingAddedItemKey = null;
      return;
    }

    // Scroll the new item into view (smooth, with header offset accounted for by scroll-padding in CSS)
    itemEl.scrollIntoView({behavior: 'smooth', block: 'nearest'});

    // Apply highlight class; CSS handles the visual transition
    itemEl.classList.add(this.HIGHLIGHT_CLASS);

    // Clean up after the animation completes
    setTimeout(() => {
      itemEl.classList.remove(this.HIGHLIGHT_CLASS);
    }, this.HIGHLIGHT_DURATION);

    this.pendingAddedItemKey = null;
  }

  async handleCartRender() {
    /* ===== Fetch cart drawer using section rendering API ===== */
    try {
      const response = await fetch(window.Shopify.routes.root + "?sections=cart-drawer");
      const responseJson = await response.json();
      if (responseJson?.['cart-drawer']) {
        this.renderCartDrawer(responseJson['cart-drawer']);
      }
    } catch (error) {
      console.error(`Failed to fetch cart drawer:`, error);
    }
  }

  getContent(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector)?.innerHTML;
  }
}

customElements.define('cart-drawer', CartDrawer);
/******/ })()
;